import * as Actions from './actionTypes';
import { generateSurveyResponse } from './utils';
import update from 'immutability-helper';
import { findIndex } from 'lodash';

const initialSurveyData = {
  loading: false,
  loadingType: "",
  error: false,
  currentPage: 0,
  totalPages: 0,
  surveyPages: [],
  surveyResponses: [],
  validateCurrentPage: false,
  submitted: false,
  submitError: false
};

const surveyData = (state = initialSurveyData, action) => {
  switch (action.type) {
    case Actions.FETCH_SURVEY_PAGE_BEGIN:
      return {
        ...state,
        loading: true,
        loadingType: "loading_survey",
        error: false
      }
    case Actions.FETCH_SURVEY_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        validateCurrentPage: false,
        currentPage: action.payload.survey_pages[0]["position"],
        totalPages: action.payload.metadata["total_survey_pages"],
        surveyPages: [...state.surveyPages, action.payload.survey_pages[0]],
        surveyResponses: [...state.surveyResponses, generateSurveyResponse(action.payload.survey_pages[0])]
      }
    case Actions.FETCH_SURVEY_PAGE_ERROR:
      return {
        ...state,
        loading: false,
        validateCurrentPage: false,
        error: action.error,
        loadingType: "error"
      }
    case Actions.CHANGE_CURRENT_SURVEY_PAGE_TO_VALUE:
      return {
        ...state,
        loading: false,
        currentPage: action.value,
        validateCurrentPage: false
      }
    case Actions.HANDLE_QUESTION_RESPONSE_CHANGE:
      let surveyResponseIndex = findIndex(state.surveyResponses, { 'surveyPagePosition': state.currentPage });
      let surveyQuestionResponseIndex = findIndex(state.surveyResponses[surveyResponseIndex].questionResponses, { 'question_id': action.payload.id });

      return update(state, {
        surveyResponses: {
          [surveyResponseIndex] : {
            questionResponses: {
              [surveyQuestionResponseIndex] : {
                [action.typeOfResponse]: {$set: action.value}
              }
            }
          }
        }
      });
    case Actions.ADD_ANSWER_IDS_TO_QUESTION_RESPONSE:
      let addSurveyResponseIndex = findIndex(state.surveyResponses, { 'surveyPagePosition': state.currentPage });
      let addSurveyQuestionResponseIndex = findIndex(state.surveyResponses[addSurveyResponseIndex].questionResponses, { 'question_id': action.payload.id });

      return update(state, {
        surveyResponses: {
          [addSurveyResponseIndex] : {
            questionResponses: {
              [addSurveyQuestionResponseIndex] : {
                answer_ids: {$push: [action.value]}
              }
            }
          }
        }
      });
    case Actions.REMOVE_ANSWER_IDS_TO_QUESTION_RESPONSE:
      let removeSurveyResponseIndex = findIndex(state.surveyResponses, { 'surveyPagePosition': state.currentPage });
      let removeSurveyQuestionResponseIndex = findIndex(state.surveyResponses[removeSurveyResponseIndex].questionResponses, { 'question_id': action.payload.id });
      let surveyQuestionResponse = state.surveyResponses[removeSurveyResponseIndex].questionResponses[removeSurveyQuestionResponseIndex];

      return update(state, {
        surveyResponses: {
          [removeSurveyResponseIndex] : {
            questionResponses: {
              [removeSurveyQuestionResponseIndex] : {
                answer_ids: {$set: (surveyQuestionResponse.answer_ids.filter(item => item !== action.value))}
              }
            }
          }
        }
      });
    case Actions.CURRENT_PAGE_NOT_VALID:
      return {
        ...state,
        validateCurrentPage: true
      }
    case Actions.SUBMIT_SURVEY_BEGIN:
      return {
        ...state,
        loading: true,
        loadingType: "submitting_survey"
      }
    case Actions.SUBMIT_SURVEY_SUCCESS:
      return {
        ...state,
        loading: true,
        submitted: true,
        submitError: false,
        loadingType: "submitting_survey"
      }
    case Actions.SUBMIT_SURVEY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        submitError: true,
        loadingType: "error"
      }
    default:
      return state
  }
}

export default surveyData;
